<template>
  <div>
    <b-row align-h="center" class="step-buttons">
      <b-col cols="11" lg="7">
        <b-row align-h="between">
          <b-link class="back-step-button" :class="{'invisible': isFirstStep }" @click="goBack">
            <font-awesome-icon :icon="['fas', 'chevron-circle-left']" size="4x" fixed-width />
          </b-link>
          <b-button variant="outline-success" class="approve-button" @click="approve">
            <font-awesome-icon :icon="['far', 'balance-scale']" size="lg" fixed-width />
            <p class="mb-0">Aprobar</p>
          </b-button>
          <b-link class="next-step-button" :class="{'invisible': isLastStep }" @click="goForward">
            <font-awesome-icon :icon="['fas', 'chevron-circle-right']" size="4x" fixed-width />
          </b-link>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ConfiguratorStepButtons',
  props: {
    isFirstStep: {
      type: Boolean,
      default: false
    },
    isLastStep: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['submitalId'])
  },
  methods: {
    approve () {
      this.$emit('saveStepData', 'approve')
    },
    goBack () {
      if (this.isFirstStep) return
      this.$emit('saveStepData', 'goBack')
    },
    goForward () {
      if (this.isLastStep) return
      this.$emit('saveStepData', 'goForward')
    }
  }
}
</script>
